export const CONTRACT_COLUMNS = [
  {
    Header: "Contract Name",
    id: "name",
    accessor: "name",
    minWidth: 220
  },
  {
    Header: "Rate",
    accessor: "billing_rate",
    id: "billing_rate",
    Cell: ({ value }) => (value ? `$${value}` : "--"),
    minWidth: 80
  },
  {
    Header: "Service Note",
    accessor: "service_note",
    id: "service_note",
    Cell: ({ value }) => value || "--",
    minWidth: 180
  }
];
